import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Spinner } from '@/shared/ui';
import { useAuth } from '../model/auth-context';

/**
 * Chroni gałąź tras przed niezalogowanymi uzytkownikami.
 *
 * Zapamietuje adres, pod ktory uzytkownik chcial wejsc, i wraca na niego
 * po zalogowaniu.
 */
export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return <Navigate to="/logowanie" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
